﻿const snapshots = new Map<string, Array<Record<string, unknown>>>();
const MAX_ROWS = 500;

export function registerChart3DSnapshot(id: string, rows: Array<Record<string, unknown>>): void {
  if (!id) return;
  if (!rows?.length) return;
  snapshots.set(id, rows.slice(0, MAX_ROWS).map((row) => ({ ...row })));
}

export function getChart3DSnapshot(id: string): Array<Record<string, unknown>> | undefined {
  return snapshots.get(id);
}

export function getChart3DSnapshots(): Record<string, Array<Record<string, unknown>>> {
  return Object.fromEntries(snapshots.entries());
}

export function loadChart3DSnapshots(value: unknown): void {
  snapshots.clear();
  if (!value || typeof value !== 'object' || Array.isArray(value)) return;
  Object.entries(value as Record<string, unknown>).forEach(([id, rows]) => {
    if (!Array.isArray(rows)) return;
    snapshots.set(id, rows.filter((row) => row && typeof row === 'object').slice(0, MAX_ROWS) as Array<Record<string, unknown>>);
  });
}
